module.exports = __webpack_public_path__ + "img/微信.34fc8345.svg";